export default __webpack_public_path__ + "static/media/security.f747f6b9.svg";